// HomeSearchBar.js
'use strict';
import { connect } from 'react-redux';
import getOperationData from '../selector/getOperationData.js';
import getListData from '../selector/getListData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getUserData from '../selector/getUserData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import submitSearchBarQuery from '../action/submitSearchBarQuery.js';
import addModal from '../action/addModal.js';
import removeModals from '../action/removeModals.js';
import fetchSearchAutoComplete from '../action/fetchSearchAutoComplete.js';
import fetchPopularSearch from '../action/fetchPopularSearch.js';
import fetchUser from '../action/fetchUser.js';

import { VIP_RECOMMEND_USER_ID } from '../RemoteConfigKeys.js';

import HomeSearchBar from '../component/HomeSearchBar.jsx';

const mapStateToProps = state => {
  const recommendUserId = getRemoteConfigData(state, VIP_RECOMMEND_USER_ID);
  const isRecommendUserFetched = recommendUserId
    ? getNetworkingData(state, ['user', recommendUserId], 'isFetched')
    : false;
  const recommendUsername = recommendUserId
    ? getUserData(state, recommendUserId, 'username')
    : '';
  const recommendDisplayName = recommendUserId
    ? getUserData(state, recommendUserId, 'displayName')
    : '';

  return {
    deviceWidth: getOperationData(state, ['device'], 'width'),
    query: getOperationData(state, ['search', 'autoComplete'], 'query'),
    autoCompleteIds: getListData(state, ['search', 'autoComplete'], 'itemIds'),
    recommendUserId,
    isRecommendUserFetched,
    recommendUsername,
    recommendDisplayName,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setSearBarQuery: ({ query }) =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['search', 'autoComplete'],
          data: { query },
        },
      }),
    submitSearchBarQuery: ({ query }) =>
      dispatch(submitSearchBarQuery({ query })),
    openModal: ({ id }) =>
      dispatch(
        addModal({
          id,
          transitionStatus: 'opening',
        })
      ),
    closeModals: ({ ids }) =>
      dispatch(
        removeModals({
          ids,
          transitionStatus: 'closing',
          skipDelay: true,
        })
      ),
    fetchSearchAutoComplete: () => dispatch(fetchSearchAutoComplete()),
    fetchPopularSearch: () => dispatch(fetchPopularSearch()),
    fetchUser: ({ id }) => dispatch(fetchUser({ id })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeSearchBar);
